import { cn } from "@/libs/utils";

type Props = {
  className?: string | any;
  value: string;
};
export default function ItemBadge({ className, value }: Props) {
  return (
    <div
      className={cn(
        "w-fit text-[10px] font-bold rounded-[15px] px-[12px] py-[4px] leading-none text-green bg-green/[.2]",
        className
      )}
    >
      {value}
    </div>
  );
}
